import { nowIso } from '../domain/time.js';
/** Well-known keys, so phases 4+ agree on spelling. */
export const SYNC_KEYS = {
    pullCursor: 'pull_cursor',
    lastPushAt: 'last_push_at',
    lastPullAt: 'last_pull_at',
    serverTimeSkewMs: 'server_time_skew_ms',
    protocolVersion: 'protocol_version',
};
export class SyncStateRepository {
    driver;
    constructor(driver) {
        this.driver = driver;
    }
    async get(key) {
        const rows = await this.driver.query({
            sql: 'SELECT value FROM sync_state WHERE key = ?',
            params: [key],
        });
        return rows[0] ? String(rows[0].value) : null;
    }
    async set(key, value) {
        // Portable update-then-insert (minSdk 26 SQLite has no upsert; ADR-002).
        const now = nowIso();
        await this.driver.batch([
            { sql: 'UPDATE sync_state SET value = ?, updated_at = ? WHERE key = ?', params: [value, now, key] },
            {
                sql: `INSERT INTO sync_state (key, value, updated_at)
              SELECT ?, ?, ? WHERE (SELECT changes()) = 0`,
                params: [key, value, now],
            },
        ]);
    }
    async remove(key) {
        await this.driver.execute({ sql: 'DELETE FROM sync_state WHERE key = ?', params: [key] });
    }
    async all() {
        const rows = await this.driver.query({ sql: 'SELECT key, value FROM sync_state' });
        return Object.fromEntries(rows.map((r) => [String(r.key), String(r.value)]));
    }
}
//# sourceMappingURL=state.js.map